'use strict';

/**
 * @classname BtnAddCart
 * @classdesc カートに追加
 */
export default class BtnAddCart {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--add-cart
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnAddCart
	 * @return undefined
	 */
	onClick() {
		if($('body').hasClass('page-preview')) return;
		console.log(`${this.constructor.name}.onClick`);

		// GA4設定
		if(window.dataLayer){
			// dataLayerがある場合
			console.log('GA4 event [add_to_cart]');
			let eCommerce;
			for(let i = 0; i < dataLayer.length; i++){
				if(window.dataLayer[i].event === 'view_item') eCommerce = window.dataLayer[i].ecommerce;
			}
			let items = eCommerce.items[0];
			items.quantity = parseInt($('#quantity').val());
			// SKU1がある商品は設定
			if($('[data-sku-no=1]')[0]){
				items.item_variant = $('[data-sku-no=1]').find('option:selected').text();
			}
			// SKU2がある商品は設定
			if($('[data-sku-no=2]')[0]){
				items.item_variant += `／${$('[data-sku-no=2]').find('option:selected').text()}`;
			}
			console.log(items);
			window.dataLayer.push({
				event: "add_to_cart",
				ecommerce: {
					items: [
						items
					]
				},
				'eventCallback': () => {
					// DataLayerにデータを送信後に通常処理へ
					this._controller.AddCart();
				},
				'eventTimeout' : 2000
			});
			// timeoutしたらそのまま遷移
			setTimeout(() => {
				this._controller.AddCart();
			}, 2500);
		}else{
			// dataLayerがない場合はそのまま通常処理へ
			this._controller.AddCart();
		}
	};
};
